module.exports = __webpack_public_path__ + "static/media/calling_a_boss.caf1f6fe.jpg";